import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import BubbleOrb from '@/components/BubbleOrb';
import { Crown, Lightning, Sparkle, ArrowRight } from '@phosphor-icons/react';

const Onboarding = () => {
  const { user } = useAuth();
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12 sm:py-20 text-center">
      <div className="chip text-bx-gold border-bx-gold/40 mb-6 mx-auto">
        <Crown size={12} weight="fill" /> Founder #{user?.founder_number || '—'}
      </div>
      <h1 className="font-display text-5xl sm:text-7xl font-black tracking-tighter leading-[0.95]">
        Welcome to <span className="shimmer-text">BubbleX.</span>
      </h1>
      <p className="text-white/70 mt-5 text-base sm:text-lg max-w-xl mx-auto">
        You're one of the first. Time to breathe the Bubble that will carry your energy into the network.
      </p>

      <div className="my-12 flex items-center justify-center">
        <BubbleOrb rarity="rare" size="lg" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
        {[
          { icon: Sparkle, title: 'Breathe', body: 'Blow your first living Bubble with an AI personality.' },
          { icon: Lightning, title: 'Pass', body: 'Share your Bubble. Every pass adds energy and velocity.' },
          { icon: Crown, title: 'Evolve', body: 'Hit milestones to evolve traits and unlock legendary status.' },
        ].map((s) => (
          <div key={s.title} className="glass rounded-2xl p-5 text-left">
            <s.icon size={22} weight="duotone" className="text-bx-cyan" />
            <div className="font-display font-bold text-lg mt-2">{s.title}</div>
            <div className="text-white/60 text-sm mt-1">{s.body}</div>
          </div>
        ))}
      </div>

      <Link
        to="/breathe"
        data-testid="onboarding-go-breathe"
        className="btn-primary px-8 py-4 rounded-full text-base inline-flex items-center gap-2 mt-12"
      >
        Breathe my first Bubble <ArrowRight size={16} weight="bold" />
      </Link>
    </div>
  );
};

export default Onboarding;
